export default {"src":"/_next/static/media/time.1ff2149f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};